import { useEffect, useState } from "react"
import { DataGridPro } from "@mui/x-data-grid-pro"

import api from "../../../api"

const columns = [
    {
        field: "created_at", type: "dateTime", headerName: "Data e Hora", flex: 1,
        valueGetter: ({ value }) => {
            if (value) {
                const date = new Date(value)
                date.setHours(date.getHours() - 3)
                return date
            }
        },
        renderCell: (params) => (
            <div>
                {params.value.toLocaleString("pt-BR")}
            </div>
        )
    },
    { field: "token_key", headerName: "Token", hide: true, flex: 1 },
    { field: "method", headerName: "Método", flex: 1 },
    { field: "path", headerName: "Endpoint", flex: 1 },
    { field: "response_time_ms", headerName: "Resposta (ms)", flex: 1 },
    { field: "status_code", headerName: "Status", flex: 1 },
    { field: "error_message", headerName: "Comentários", flex: 1 },
]

const PublicAPIReport = ({ enterpriseId }) => {
    const [rows, setRows] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const loadData = async () => {
            try {
                setLoading(true)

                const response = await api.get(`/api/enterprises/${enterpriseId}/public_api_request/`)
                
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(
                        response.data?.detail ??
                        `Request failed with status ${response.status}`
                    )
                }

                setRows(response.data)
            } catch (error) {
                console.error("Failed to load report", error)
                setRows([])
            } finally {
                setLoading(false)
            }
        }

        loadData()
    }, [])

    return (
        <DataGridPro
            rows={rows}
            columns={columns}
            loading={loading}
            disableRowSelectionOnClick
            density="compact"
            hideFooter={true}
        />
    )
}

export default PublicAPIReport
